export default __webpack_public_path__ + "static/media/home-star.8c58bec2.svg";